/**
 * Phase 5 - Task 12: Wayne feature-flag REST helpers.
 *
 * The single endpoint exposed today is `/api/feature-flags/fullauto`,
 * which proxies the locked AppConfig application
 * `wayne-fullauto-config` (see WayneAIPlatformCDK Phase 5 - Task 2).
 * Backend reads the agent on `localhost:2772` and re-emits the JSON
 * unchanged so the frontend shape mirrors the AppConfig hosted
 * configuration document.
 */
import { wayneFetch } from './wayneFetch';

export interface FullAutoFlags {
  readonly enabled: { readonly beta: boolean; readonly prod: boolean };
  readonly allowedUsers: readonly string[];
  readonly allowedPackages: readonly string[];
  readonly dailyCap: number;
}

export async function fetchFullAutoFlags(): Promise<FullAutoFlags> {
  return wayneFetch<FullAutoFlags>('/feature-flags/fullauto', {
    method: 'GET',
  });
}

/**
 * The `chat` AppConfig profile (WayneAIPlatformCDK Phase 5 - Task 19).
 * Shape mirrors the hosted configuration document:
 *   { "multistream": { "enabled": boolean } }
 * Beta defaults `multistream.enabled=true`; Prod ships `false` until the
 * Playwright e2e gate passes. The backend re-emits the AppConfig JSON
 * unchanged from `/api/feature-flags/chat`.
 */
export interface ChatFlags {
  readonly multistream: { readonly enabled: boolean };
}

export async function fetchChatFlags(): Promise<ChatFlags> {
  return wayneFetch<ChatFlags>('/feature-flags/chat', {
    method: 'GET',
  });
}
